import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBranding } from '../context/BrandingContext';
import { useFeature, useFeatureFlagsReady } from '../context/FeatureFlagContext';
import { PageShell } from '../components/UI';
import { ServiceCard, AdCarousel } from './customer/CustomerPortal';

// Signed-out landing page at "/" — lets a visitor see what's offered without creating an
// account first (mirrors the guest browse screen shipped for the mobile app). Every card still
// routes to Sign In to actually act on it; only the ability to see the menu changed. Reuses
// CustomerPortal's own ServiceCard/AdCarousel and PageShell so this never visually drifts from
// the logged-in Services view.
export default function GuestServicesPage() {
    const navigate = useNavigate();
    const branding = useBranding();
    const svcNoun = branding.serviceNoun ?? null;
    const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
    const dumpsterEnabled = useFeature('dumpsterRental');
    const estimateBuilderEnabled = useFeature('estimateBuilder');
    const flagsReady = useFeatureFlagsReady();

    const goSignIn = () => navigate('/login');

    const nav = (
        <button onClick={goSignIn} style={{ background: 'transparent', border: '1px solid var(--color-accent, #4ADE80)', color: 'var(--color-accent, #4ADE80)', padding: '6px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
            Sign in
        </button>
    );

    return (
        <PageShell title="Services" nav={nav}>
            <div style={{ overflowX: 'auto', paddingBottom: 8 }}>
                <div style={{ display: 'flex', gap: 20, minWidth: 'max-content' }}>
                    <ServiceCard
                        icon={svcNoun === 'pickup' ? '📦' : '🛠️'}
                        title={svcNoun ? `Schedule a ${cap(svcNoun)}` : 'Request a Service'}
                        description={branding.serviceDescription ?? 'We come to you — book online in minutes'}
                        buttonText="Sign in to book →"
                        onClick={goSignIn}
                    />
                    {flagsReady && dumpsterEnabled && (
                        <ServiceCard icon="🚛" title="Rent a Dumpster" description="Delivery + optional loading runners"
                            buttonText="Sign in to browse →" onClick={goSignIn} />
                    )}
                    {flagsReady && estimateBuilderEnabled && (
                        <ServiceCard icon="📋" title="Request/View an Estimate" description="Request a quote or check on one you've sent"
                            buttonText="Sign in to request →" onClick={goSignIn} />
                    )}
                    <ServiceCard icon="🎁" title="Send a Gift" description="Buy a pickup for someone else — we'll email them the code"
                        buttonText="Sign in to send a gift →" onClick={goSignIn} />
                </div>
            </div>
            <div style={{ marginTop: 28 }}>
                <AdCarousel onViewPlans={goSignIn} />
            </div>
        </PageShell>
    );
}
